<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">مشاوره و راهکارهای پیشرفته برای بازرگانان و تجار</h3>
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto px-0">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">مشاوره و راهکارهای پیشرفته ما برای بازرگانان و تجار</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای پرشتاب تجارت بین‌الملل و داخلی، بازرگانان و تجار برای موفقیت نیازمند راهکارهای نوین، استراتژی‌های هدفمند و بهره‌گیری از فناوری‌های پیشرفته هستند. ما با ارائه خدمات تخصصی در حوزه مشاوره، دیجیتال‌سازی، تحلیل بازار و مدیریت زنجیره تأمین، به شما کمک می‌کنیم تا رقابت‌پذیری خود را افزایش داده و فرصت‌های جدیدی در بازارهای داخلی و بین‌المللی کشف کنید.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">نیازهای بازرگانان و چالش‌های موجود</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>عدم شناخت دقیق بازارهای هدف:</strong>عدم دسترسی به داده‌های تحلیلی و روندهای بازار می‌تواند باعث تصمیم‌گیری‌های اشتباه شود.
                                </li>
                                <li class="mt-3">
                                    <strong>مشکلات لجستیکی و زنجیره تأمین:</strong>حمل‌ونقل، تأمین کالا و مدیریت زنجیره تأمین یکی از چالش‌های اصلی تجارت است.
                                    نوسانات ارزی و تغییرات قوانین تجاری: تجارت بین‌المللی با ریسک‌های ارزی و قوانین متغیر همراه است که بر سودآوری تأثیر می‌گذارد.
                                </li>
                                <li class="mt-3">
                                    <strong>نیاز به دیجیتال‌سازی فرآیندهای تجاری:</strong>استفاده از ابزارهای دیجیتال و هوش مصنوعی برای بهینه‌سازی کسب‌وکار تجاری ضروری است.</li>
                                <li class="mt-3">
                                    <strong>کیفیت و استانداردهای تولید:</strong> رعایت استانداردهای کیفیت برای حفظ رقابت‌پذیری ضروری است.</li>
                                <li class="mt-3">
                                    <strong>چالش‌های بازاریابی و جذب مشتریان جدید:</strong>ورود به بازارهای جدید نیازمند استراتژی‌های بازاریابی دیجیتال و برندینگ قوی است.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما برای بازرگانان و تجار</h3>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">تحلیل بازار و مشاوره توسعه کسب‌وکار</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل بازارهای داخلی و بین‌المللی برای شناسایی فرصت‌های تجاری</li>
                                <li>بررسی رقبا و ارائه استراتژی‌های رقابتی</li>
                                <li>تدوین استراتژی ورود به بازارهای جدید</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/Analyze.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/Business.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> دیجیتال‌سازی و بهینه‌سازی فرآیندهای تجاری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پیاده‌سازی سیستم‌های مدیریت ارتباط با مشتری (CRM) برای افزایش فروش</li>
                                <li>اتوماسیون فرآیندهای سفارش و مدیریت انبار</li>
                                <li>راهکارهای هوشمند برای پیش‌بینی تقاضا و کنترل موجودی</li>
                            </ul>    
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Business.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">مشاوره لجستیک و مدیریت زنجیره تأمین</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ارائه راهکارهای بهینه‌سازی حمل‌ونقل و توزیع کالا</li>
                                <li>کاهش هزینه‌های زنجیره تأمین از طریق فناوری‌های نوین</li>
                                <li>راهکارهای هوشمند برای ردیابی و مدیریت موجودی کالا</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مشاوره مالی، ارزی و مدیریت ریسک تجارت بین‌الملل</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل و مدیریت ریسک‌های ارزی برای کاهش تأثیر نوسانات بازار</li>
                                <li>استراتژی‌های تأمین مالی و سرمایه‌گذاری در بازارهای بین‌المللی</li>
                                <li>راهکارهای مدیریت نقدینگی و بهینه‌سازی جریان مالی</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/img11.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">برندینگ و بازاریابی دیجیتال برای تجارت بین‌الملل</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تدوین استراتژی بازاریابی بین‌المللی برای جذب مشتریان خارجی</li>
                                <li>ایجاد کمپین‌های تبلیغاتی دیجیتال و افزایش دیده شدن برند</li>
                                <li>بهینه‌سازی وب‌سایت و سئو برای جذب مشتریان از سراسر جهان</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img21.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/contract.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مشاوره حقوقی و تنظیم قراردادهای تجاری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تهیه و بررسی قراردادهای تجاری بین‌المللی</li>
                                <li>مشاوره در حوزه حقوق تجارت و رعایت الزامات قانونی صادرات و واردات</li>
                                <li>راهکارهای مدیریت دعاوی تجاری و حل‌وفصل اختلافات</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/contract.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">آموزش و توانمندسازی تجار و بازرگانان</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>برگزاری کارگاه‌های تخصصی در زمینه تجارت الکترونیک و صادرات</li>
                                <li>آموزش مهارت‌های مذاکره تجاری و اصول تجارت بین‌المللی</li>
                                <li>ارائه دوره‌های ویژه برای بهینه‌سازی استراتژی‌های خرید و فروش</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/learning.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../assets/services-img/Business2.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">راهکارهای فناوری برای هوشمندسازی تجارت</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پیاده‌سازی هوش مصنوعی برای تحلیل روندهای بازار</li>
                                <li>استفاده از بلاکچین برای امنیت قراردادهای تجاری</li>
                                <li>راهکارهای داده‌محور برای تصمیم‌گیری سریع و بهینه</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end d-md-none d-block">
                        <img src="../../assets/services-img/Business2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px; padding-left: 200px;">
            <div class="container my-5 py-3">
                <h3 class="my-5 text-end">نتایج و ارزش‌آفرینی برای بازرگانان و تجار</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/precision.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش دقت در تصمیم‌گیری‌های تجاری</strong>  از طریق تحلیل‌های دقیق بازار 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/production.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>کاهش هزینه‌های لجستیک و زنجیره تأمین</strong> با راهکارهای نوین مدیریت لجستیک
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش سودآوری و کاهش ریسک‌های ارزی</strong> با استراتژی‌های مالی هوشمند 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img14.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش سودآوری و کاهش ریسک‌های ارزی</strong> با استراتژی‌های مالی هوشمند 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/img21.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهبود بازاریابی و جذب مشتریان بیشتر</strong> از طریق دیجیتال‌سازی و تبلیغات هدفمند 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/market.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>توسعه کسب‌وکار و ورود به بازارهای بین‌المللی </strong> با استراتژی‌های تجاری سفارشی 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم از خدمات شما برای تجارت خود استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        شما می‌توانید از طریق تماس با تیم مشاوره ما، نیازهای خود را مطرح کنید. پس از بررسی دقیق، راهکارهای مناسب ارائه خواهد شد.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا این خدمات برای کسب‌وکارهای کوچک نیز مناسب است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما راهکارهایی برای تمام سطوح کسب‌وکار از شرکت‌های کوچک تا بازرگانان بزرگ طراحی می‌کنیم.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6>آیا خدمات مشاوره شما شامل پشتیبانی اجرایی نیز می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، علاوه بر ارائه مشاوره، ما در اجرای راهکارهای پیشنهادی نیز همراه شما خواهیم بود.
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>چگونه می‌توانم ریسک‌های ارزی را در تجارت خود کاهش دهم؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        ما استراتژی‌های مالی و راهکارهای پوشش ریسک را ارائه می‌دهیم که به شما در مدیریت نوسانات ارزی کمک می‌کند.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>آیا امکان دریافت مشاوره تخصصی در حوزه بازاریابی دیجیتال وجود دارد؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما خدمات تخصصی در زمینه بازاریابی دیجیتال برای افزایش دیده شدن و جذب مشتریان ارائه می‌دهیم.
                        <br>
                        ما در کنار شما هستیم تا تجارتتان را به سطح بالاتری برسانید. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>